<template>
    <div class="card-generator-loader">
        <span class="loader"></span>
        <span style="margin-top:1rem;">procesando</span>
        <span class="smallinfotext">Este proceso puede tardar unos minutos. Gracias por su paciencia.</span>
    </div>
</template>

<script>
    export default {

    }
</script>

<style>
    .card-generator-loader {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        color: #006aff;
        font-weight: 700;
        overflow: hidden;
    }


    .loader {
        width: 48px;
        height: 48px;
        border: 5px solid #006aff;
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    } 
</style>